import React, { useEffect, useMemo, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import BeforeAfter from "../components/gallery/BeforeAfter";
import { getPublicGallery } from "../api";
import { SERVICES } from "../lib/services";
import { Images, MapPin, ArrowRight, Loader2 } from "lucide-react";
import { log } from "../lib/log";

const FILTERS = [{ key: "", label: "Toutes" }, ...Object.entries(SERVICES).map(([k, s]) => ({ key: k, label: s.label }))];

export default function Realisations() {
  const [items, setItems] = useState(null);
  const [filter, setFilter] = useState("");
  useEffect(() => { getPublicGallery().then((r) => setItems(r.data.items || [])).catch((e) => { log.error("galerie:", e); setItems([]); }); }, []);
  const shown = useMemo(() => (items || []).filter((i) => !filter || i.service === filter), [items, filter]);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header solid />
      <main className="flex-1" data-testid="realisations-page">
        <section className="max-w-6xl mx-auto px-5 pt-12 md:pt-16 pb-8">
          <p className="text-xs font-semibold tracking-[0.2em] text-brand uppercase mb-4 flex items-center gap-2"><Images size={14} /> Réalisations</p>
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl text-neutral-900 leading-tight">Avant / après : le résultat, <span className="text-brand">sans retouche</span></h1>
          <p className="text-neutral-600 mt-6 text-base md:text-lg max-w-2xl">Nos intervenants photographient chaque site à l'arrivée et au départ. Voici une sélection de chantiers de nettoyage, d'espaces verts et de petits travaux, publiés avec l'accord de nos clients (sans nom d'entreprise). Faites glisser le curseur pour comparer.</p>
          <div className="flex flex-wrap gap-2 mt-8" data-testid="gallery-filters">
            {FILTERS.map((f) => <button key={f.key} onClick={() => setFilter(f.key)} data-testid={`gallery-filter-${f.key || "all"}`} className={`text-sm font-semibold px-4 py-2 rounded-full border transition-colors ${filter === f.key ? "bg-neutral-900 text-white border-neutral-900" : "border-neutral-300 text-neutral-700 hover:border-neutral-900"}`}>{f.label}</button>)}
          </div>
        </section>

        <section className="max-w-6xl mx-auto px-5 pb-16">
          {items === null ? <p className="text-neutral-400 flex items-center gap-2"><Loader2 size={16} className="animate-spin" /> Chargement…</p>
            : shown.length === 0 ? <p className="text-neutral-500" data-testid="gallery-empty">Aucune réalisation publiée dans cette catégorie pour le moment.</p>
            : (
              <div className="grid md:grid-cols-2 gap-8" data-testid="gallery-grid">
                {shown.map((it) => {
                  const s = SERVICES[it.service] || SERVICES.clean;
                  return (
                    <article key={it.id} className="group" data-testid={`gallery-item-${it.id}`}>
                      <BeforeAfter before={it.before} after={it.after} alt={it.title} testid={`gallery-compare-${it.id}`} />
                      <div className="mt-4 flex items-start justify-between gap-3">
                        <div>
                          <h2 className="font-heading font-bold text-neutral-900">{it.title}</h2>
                          <p className="text-sm text-neutral-500 flex items-center gap-1 mt-0.5"><MapPin size={13} /> {it.ville || "Hauts-de-France"}{it.date ? ` · ${new Date(it.date).toLocaleDateString("fr-FR", { month: "long", year: "numeric" })}` : ""}</p>
                          {it.caption && <p className="text-sm text-neutral-600 mt-2">{it.caption}</p>}
                        </div>
                        <span className={`shrink-0 inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-0.5 rounded-full ${s.cls}`}><s.icon size={11} /> {s.label}</span>
                      </div>
                      {it.demo && <p className="text-[11px] text-neutral-400 mt-1">Visuel d'illustration</p>}
                    </article>
                  );
                })}
              </div>
            )}
        </section>

        <section className="max-w-6xl mx-auto px-5 pb-16 md:pb-24">
          <div className="bg-neutral-950 text-white rounded-2xl p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div><p className="font-heading font-bold text-xl">Votre site mérite le même résultat</p><p className="text-neutral-400 text-sm mt-1">Devis gratuit sous 24 h — nettoyage, espaces verts, homme toutes mains.</p></div>
            <a href="/#devis" className="inline-flex items-center gap-2 bg-brand hover:bg-brand-dark text-white font-semibold px-5 py-3 rounded-md" data-testid="gallery-cta">Demander un devis <ArrowRight size={16} /></a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
